import React, { Component } from 'react'
import Keen from 'keen-js'
import { object, string } from 'prop-types'

// utils
import { createQuery, runQuery, createQueryCTA } from '../../../utils/KeenReport'

// components
import Spinner from '../../Spinner'
import CompleteFunnelGraph from '../CompleteFunnelGraph'

class CompleteFunnelChart extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: true,
      hasError: false,
      recommends: 'Carregando...',
      plays: 'Carregando...',
      playrate: 'Carregando...'
    }

    this.runKeen = this.runKeen.bind(this)
    this.toggleVideoPlay = this.toggleVideoPlay.bind(this)
  }
  componentDidMount () {
    this.runKeen(this.props)
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.timeframe !== this.props.timeframe) {
      this.runKeen(nextProps)
    }
  }
  toggleVideoPlay (hasVideoPlay) {
    this.setState({
      hasVideoPlay
    }, () => { this.runKeen(this.props) })
  }
  runKeen (props) {
    Keen.ready(() => {
      let { campaign, actor, timeframe, video, filters } = props
      let { hasVideoPlay } = this.state
      let queries
      this.setState({
        isLoading: true,
        hasError: false
      })
      if (actor === 'pessoas') {
        queries = [
          createQuery('count_unique', 'video_recomended', timeframe, campaign, video, 'client_viewer_id', null, filters),
          createQuery('count_unique', 'video_unique_click', timeframe, campaign, video, 'client_viewer_id', null, filters)
        ]
        if (video && video.conversion_filter && video.conversion_filter_group_by) {
          queries.push(
            createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...video.conversion_filter, ...filters ], video.conversion_filter_group_by),
            createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...video.nav_filter, ...filters], video.nav_filter_group_by)
          )
        } else {
          queries.push(
            createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, filters),
            createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [
              {'operator':'eq','property_name':'source','property_value':'nav'},
              ...filters
            ], ['value'])
          )
        }
        queries.push(createQuery('count_unique', 'video_unique_play', timeframe, campaign, video.player_video_id, 'client_viewer_id', null, filters))
      } else {
        queries = [
          createQuery('count', 'video_recomended', timeframe, campaign, video, null, null, filters),
          createQuery('count', 'video_unique_click', timeframe, campaign, video, null, null, filters)
        ]
        if (video && video.conversion_filter && video.conversion_filter_group_by) {
          queries.push(
            createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, [...video.conversion_filter, ...filters], video.conversion_filter_group_by),
            createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, [...video.nav_filter, ...filters], video.nav_filter_group_by)
          )
        } else {
          queries.push(
            createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, filters),
            createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, [...video.nav_filter, ...filters], video.nav_filter_group_by)
          )
        }
        queries.push(createQuery('count', 'video_unique_play', timeframe, campaign, video.player_video_id, null, null, filters))
      }
      runQuery(queries)
        .then((res) => {
          let recommends = res[0].result
          let plays = res[1].result
          let navCountsArray = res[3].result
          let videoPlays = res[4].result

          let totalClicks
          if (Array.isArray(res[2].result)) {
            totalClicks = res[2].result.reduce((initialValue, currentValue) => {
              let valor = initialValue + currentValue.result
              return valor
            }, 0)
          } else {
            totalClicks = res[2].result
          }

          let conversion = {}

          if (Array.isArray(res[2].result)) {
            conversion = res[2].result.reduce((initialValue, currentValue, index) => {
              var groupIndex = initialValue['group'].findIndex((group) => {
                let valueToCompare = currentValue.last_nav || '(direto)'
                return group.label === valueToCompare
              })

              if (groupIndex === -1) {
                initialValue['group'].push({
                  label: currentValue.last_nav || '(direto)',
                  value: 0,
                  childrens: [{
                    label: currentValue.value,
                    value: currentValue.result
                  }]
                })
              } else {
                initialValue['group'][groupIndex].childrens.push({
                  label: currentValue.value,
                  value: currentValue.result
                })
              }

              return initialValue
            }, { type: 'group', label: 'Navegação', group: [] })

            if (navCountsArray.length > 0) {
              for (var i = 0; i < conversion.group.length; i++) {
                for (var j = 0; j < navCountsArray.length; j++) {
                  if (conversion.group[i].label === navCountsArray[j].value) {
                    conversion.group[i].value = navCountsArray[j].result
                  }
                }
              }
            }
          }

          let dataForGraph = [
            { label: 'Recomendações', value: recommends, type: 'line', rate: 1 },
            { label: `Plays`, value: plays, type: 'line', rate: plays / recommends }
          ]

          let conversionRate
          if (hasVideoPlay) {
            dataForGraph.push({ label: 'Player tocar video', value: videoPlays, type: 'line', color: '#ad48a1', rate: (videoPlays / plays) })
            conversionRate = totalClicks / videoPlays
          } else {
            conversionRate = totalClicks / plays
          }

          if (!conversion.group || (conversion.group.length === 1 && conversion.group[0].label === '(direto)')) {
            conversion = {
              label: 'Conversão',
              value: totalClicks,
              type: 'line',
              color: '#EF8838',
              rate: conversionRate
            }
            dataForGraph.push(conversion)
          } else {
            dataForGraph.push(conversion)
            dataForGraph.push({ label: 'Conversão', value: totalClicks, type: 'line', rate: conversionRate })
          }

          this.setState({
            isLoading: false,
            hasError: false,
            dataForGraph
          })
        }, (err) => {
          console.log('Erro rodando a query do Keen.', err)
          this.setState({
            hasError: true
          })
        })
    })
  }
  render () {
    let { isLoading, hasError } = this.state
    const { video } = this.props
    return (
      <div>
        <div className={isLoading ? 'hidden' : ''}>
          <CompleteFunnelGraph
            dataForGraph={this.state.dataForGraph}
            funnelType={video.funnel_type}
            toggleVideoPlay={this.toggleVideoPlay}
          />
        </div>
        <Spinner isLoading={isLoading} hasError={hasError} runKeen={() => { this.runKeen(this.props) }} />
      </div>
    )
  }
}

CompleteFunnelChart.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
}

export default CompleteFunnelChart



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/LastNavFunnel.js